import React from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export const Contact = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <form action="mailto:contact@rezylist.com" method="get">
        <div
          style={{
            width: '50em',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h4" component="h4">
            Contact Us
          </Typography>
          <TextField
            margin="dense"
            id="name"
            name="name"
            label="Name"
            fullWidth
          />
          <TextField
            margin="dense"
            id="email"
            name="email"
            label="Email"
            type="email"
            fullWidth
          />
          <TextField
            margin="dense"
            id="notes"
            name="notes"
            label="Message"
            type="notes"
            minRows="7"
            multiline
            fullWidth
          />
          <Button type="submit" variant="contained">
            Send Message
          </Button>
        </div>
      </form>
    </div>
  );
};
